<template>
  <header :class="{ sticky: isSticky }">
    <div class="toolbar">
      <div class="toolbar_box">
        <p>
          <span>欢迎您,<router-link :to="{ name: userInfo ? 'user' : 'visa' }">{{ userInfo ? userInfo.contact_name : "常顺旅游"
          }}!
            </router-link></span>
          <template v-if="!userInfo">
            <router-link :to="{ path: '/register' }">注册</router-link><span> | </span><router-link
              :to="{ path: '/login' }">登录</router-link>
          </template>
          <template v-else>
            <el-popconfirm title="确定退出登录嘛？" @confirm="signOut">
              <a slot="reference">退出登录</a>
            </el-popconfirm>
          </template>
          <i class="icon-telephone"></i><span class="concatPhone">0755-22658484</span>
        </p>
        <nav>
          <template v-if="userInfo">
            <router-link :to="{ path: '/orderCenter' }"><i class="icon-yonghu"></i><span>我的订单</span></router-link>
            <!-- <a href=""><i class="icon-gouwuche"></i><span>购物车</span></a> -->
          </template>
          <a class="strong" @click="$message.info('功能开发中，敬请期待！')"><i class="icon-zhengjian"></i><span>签证进度查询</span></a>
          <el-popover placement="bottom" width="150" trigger="hover">
            <img class="wx" src="@assets/img/cserweima.jpg" alt="" />
            <a slot="reference"><i class="icon-ai-weixin"></i> <span>官方微信</span></a>
          </el-popover>
        </nav>
      </div>
    </div>
    <div class="info">
      <div class="info_box">
        <figure class="nav">
          <a href="./" class="logo"><img src="@assets/img/logo.png" alt="" /></a>
          <nav>
            <router-link exact-active-class="on" to="/">首页</router-link>
            <router-link exact-active-class="on" to="/visa">签证</router-link>
            <router-link exact-active-class="on" to="/tour">旅游度假</router-link>
            <!-- <router-link exact-active-class="on" to="/travel">新-旅游</router-link> -->
            <a @click="hintNo">机票</a>
            <router-link exact-active-class="on" to="/hotel">酒店</router-link>
          </nav>
        </figure>
        <!-- <search @change="selectedItem"/> -->
      </div>
    </div>
    
  </header>
</template>

<script>
import search from "@components/search";
import { mapState, mapMutations } from "vuex"; // 引入 mapMutations

export default {
  components: {
    search,
  },
  props: {
    isSticky: {
      type: Boolean,
      value: false,
    },
  },
  data() {
    return {};
  },
  created() { },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    // 从 Vuex 映射 mutations（注意：clearUserInfo 已在 store 中定义）
    ...mapMutations(['clearUserInfo']),

    // hintNo函数：提示功能开发中
    hintNo() {
      this.$message.info("功能开发中，敬请期待～");
    },

    // selectedItem函数：搜索选中后跳转
    selectedItem(data) {
      const { id, name } = data;
      this.$router.push({ path: "./visa_list", query: { id, name } });
    },

    // signOut函数：退出登录
    signOut() {
      // 1. 清除 localStorage 中的用户信息
      localStorage.removeItem('userInfo');
      // 2. 调用 Vuex mutation 清除 state 中的 userInfo
      this.clearUserInfo();
      // 3. 跳转到首页（签证页）
      this.$router.push({ name: "visa" });
    },
  },
};
</script>

<style scoped src="./index.css"></style>